import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const parse = (t) => t.split(",").map((s) => s.trim()).filter(Boolean);

/** Comma-separated list input — keeps the raw text while typing so commas and spaces survive. */
export const CsvInput = ({ value = [], onChange, ...rest }) => {
  const [text, setText] = useState((value || []).join(", "));

  useEffect(() => {
    const incoming = (value || []).join("|");
    if (incoming !== parse(text).join("|")) setText((value || []).join(", "));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(value || []).join("|")]);

  return (
    <Input {...rest} value={text}
      onChange={(e) => { setText(e.target.value); onChange(parse(e.target.value)); }} />
  );
};
